import { EntityService } from "@/model/service/entity-service"
import { PostalCode } from "@/model/entity/postal-code/postal-code"
import { AxiosPromise } from "axios"
import { plainToClass } from "class-transformer"
import { Filter } from "@/model/dto/filter"
import { DatatableSort } from "@/model/dto/datatable-sort"
import { Page } from "@/model/dto/page"

class PostalCodeService extends EntityService<PostalCode> {
  constructor() {
    super("dpd_tours", PostalCode)
  }

  getPage(page: number, rows: number, filters: Filter[], sort?: DatatableSort): AxiosPromise<Page<any>> {
    return this.$http.get(this.path + this.buildQueryParams(filters, page - 1, rows, sort)).then(response => {
      response.data.content = plainToClass(this.classType, response.data.content)
      return response
    })
  }

  create(entity: PostalCode): AxiosPromise<PostalCode> {
    return super.create(entity).then(response => {
      return response
    })
  }
  delete(id: number): AxiosPromise<void> {
    return this.$http.delete(this.path + "/" + id)
  }
}

export interface IPostalCodeService extends EntityService<PostalCode> {}

const service = new PostalCodeService()

export const postalCodeService = service
